module.exports = __webpack_public_path__ + "img/jg.ed220d9a.png";